import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppShell from './components/AppShell';
import Dashboard from './pages/Dashboard';
import ArtifactViewer from './pages/ArtifactViewer';
import ActivityFeed from './pages/ActivityFeed';
import Settings from './pages/Settings';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import AuthGoogleRedirect from './pages/AuthGoogleRedirect';
import SharedArtifactViewer from './pages/SharedArtifactViewer';
import InviteAccept from './pages/InviteAccept';
import UserSettings from './pages/UserSettings';
import SlackCallback from './pages/SlackCallback';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login and auth callback are outside the app shell */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/google" element={<AuthGoogleRedirect />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/slack/callback" element={<SlackCallback />} />
        <Route path="/invite/:token" element={<InviteAccept />} />
        <Route path="/share/:id" element={<SharedArtifactViewer />} />

        {/* App shell wraps all authenticated routes */}
        <Route element={<AppShell />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/a/:id" element={<ArtifactViewer />} />
          <Route path="/a/:id/v/:version" element={<ArtifactViewer />} />
          <Route path="/inbox" element={<ActivityFeed />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/members" element={<Settings />} />
          <Route path="/me" element={<UserSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
